import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { serverError } from 'src/utils';

const mutation = gql`
mutation UpdateMagnetTimeout($id: ID!, $model: MagnetTimeoutInput!) {
  updateMagnetTimeout(id: $id, magnetTimeout: $model) {
  id
  magnetTimeout
  team {
    id
    name
  }
  channel {
    id
    name
  }
  requestType {
    id
    name
  }
  }
}`;

const fieldsName = {
  message: 'T_MAGNET_TIMEOUT',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

function updateMagnet(id, model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
      model,
    },
  }).then((res) => res.data.updateMagnetTimeout)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        throw errors.map(onParseErrors);
      } else {
        throw err;
      }
    });
}

export default updateMagnet;
